const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const PlanningCommandURL: any = {
    PostPlanning: Backofficebff + '/v1/shotdelivery/planings',
    PostPlanningShot: Backofficebff + '/v1/shotdelivery/shot-in-photography-stages',
    PutPlanning: Backofficebff + '/v1/shotdelivery/planings',
    DeletePlanningShot: Backofficebff + '/v1/shotdelivery/delete-shot-in-photography-stages',
};
